<div class="permissions-list">
    <div class="tableFixHead">
        <table class="table">
            <thead>
                <tr>
                    <th scope="col" class="accordion custom-accordion w-50 text-capitalize">
                        <h3>{{role.name}}</h3>
                    </th>
                    <th scope="col" class="text-center clickable" (click)="modifyColumnPermissions($event, 'view')">{{words[language][ 'view' ]}}</th>
                    <th scope="col" class="text-center clickable" (click)="modifyColumnPermissions($event, 'add')">{{words[language][ 'add' ]}}</th>
                    <th scope="col" class="text-center clickable" (click)="modifyColumnPermissions($event, 'modify')">{{words[language][ 'edit' ]}}</th>
                    <th scope="col" class="text-center clickable" (click)="modifyColumnPermissions($event, 'delete')">{{words[language][ 'delete']}}</th>
                </tr>
            </thead>
            @for (module of modules; track module; let i = $index) {
                <tbody>
                    <tr>
                        <th scope="col" class="text-left clickable" (click)="modifyModulePermissions($event, module)">{{module}}</th>
                        <th scope="col" class="text-center"></th>
                        <th scope="col" class="text-center"></th>
                        <th scope="col" class="text-center"></th>
                        <th scope="col" class="text-center"></th>
                    </tr>
                    @for (permission of permissions[module]; track permission) {
                        <tr id="page_{{permission.id}}_permissions" class="border-top permissions">
                            <td class="indent-lvl-{{permission.indent}} clickable" (click)="modifyPagePermissions(permission.id)">{{words[language][permission.name]}} </td>
                            <td class="text-center">
                                @if (permission.indent > 0) {
                                    <input [id]="'view_' + permission.id" type="checkbox" [checked]="permission.view" (change)="modifySinglePermission(permission, 'view')">
                                }
                            </td>
                            <td class="text-center">
                                @if (permission.indent > 0) {
                                    <input [id]="'add_' + permission.id" type="checkbox" [checked]="permission.add" (change)="modifySinglePermission(permission, 'add')">
                                }
                            </td>
                            <td class="text-center">
                                @if (permission.indent > 0) {
                                    <input [id]="'modify_' + permission.id" type="checkbox" [checked]="permission.modify" (change)="modifySinglePermission(permission, 'modify')">
                                }
                            </td>
                            <td class="text-center">
                                @if (permission.indent > 0) {
                                    <input [id]="'delete_' + permission.id" type="checkbox" [checked]="permission.delete" (change)="modifySinglePermission(permission, 'delete')">
                                }
                            </td>
                        </tr>
                    }
                </tbody>
            }
        </table>
    </div>
</div>

<!-- loading -->
@if (loading) {
    <div class="w-100 py-5 d-flex justify-content-center align-items-center">
        <div class="spinner-grow avatar-lg text-secondary my-5" role="status"></div>
    </div>
}